var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('site-header',{attrs:{"language":_vm.language},on:{"change-language":_vm.setLanguage}}),_c('main',{staticClass:"page-shell"},[_c('router-view',{attrs:{"language":_vm.language}})],1),(_vm.$route.path !== '/')?_c('site-footer',{attrs:{"language":_vm.language}}):_vm._e(),_c('back-to-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }